import { uploadEHRNote } from '@ax/service';
import { UploadEHRNoteInput } from '@ax/service/src/ehr-interface';
import { useMutation } from '@tanstack/react-query';

export function useUploadEHRNoteApi() {
  const uploadEHRNoteMutation = useMutation({
    mutationKey: ['upload-ehr-appointment'],
    mutationFn: (data: UploadEHRNoteInput) => uploadEHRNote(data),
    onError: (error: any) => {
      return error;
    },
  });

  return uploadEHRNoteMutation;
}
